import { Controller } from 'stimulus';
import { mountTiptapEditor, destroyTiptapEditor } from '../entrypoints/src/admin/editor/create_editor';
import 'tippy.js/themes/light.css';
import '../entrypoints/src/admin/editor/editor.scss';

// Generic Tiptap editor for a single <textarea> with no preview modal. Opt into merge
// tags by setting data-variables (dictionary groups JSON) on the textarea, and into
// @-mentions by setting data-mention-url (candidates endpoint). Used for plain
// rich-text fields such as service content descriptions and ticket replies.
export default class extends Controller {
  connect() {
    const groups = this.element.dataset.variables ? JSON.parse(this.element.dataset.variables) : [];
    const mentionUrl = this.element.dataset.mentionUrl || null;
    const uploadUrl = this.element.dataset.uploadUrl || null;
    const variant = this.element.dataset.variant || null;
    // Bubble variant only: set data-floating-menu="false" to disable the empty-line menu.
    const floatingMenu = this.element.dataset.floatingMenu !== 'false';
    // Set data-sticky-toolbar="true" when the editor lives inside a scrolling panel
    // (e.g. the announcements drawer) so the toolbar stays reachable while scrolling.
    const stickyToolbar = this.element.dataset.stickyToolbar === 'true';
    this.editor = mountTiptapEditor(this.element, { groups, mentionUrl, uploadUrl, variant, floatingMenu, stickyToolbar });
  }

  disconnect() {
    destroyTiptapEditor(this.editor);
  }
}
